export default __webpack_public_path__ + "static/media/siteLogo2.aace065c.png";